import React, { useState } from 'react';
import '../styles/components/button.css';

const AgreeButton = ({
 children,
 width,
 height,
 padding,
 backgroundColor,
 color,
 onClick,
 className = '',
 checked = false,
 onChange,
 ...props
}) => {
 const [isChecked, setIsChecked] = useState(checked);

 const handleClick = () => {
   const newChecked = !isChecked;
   setIsChecked(newChecked);
   if (onChange) {
     onChange(newChecked);
   }
   if (onClick) {
     onClick();
   }
 };

 return (
   <button
     className={`agree-button ${className} gmarket-font`}
     onClick={handleClick}
     {...props}
   >
   <div className={`custom-checkbox ${isChecked ? 'checked' : ''}`}>
        {isChecked && <span className="checkmark"></span>}
      </div>
     <span className="agree-text">{children}</span>
   </button>
 );
};

export default AgreeButton;